import type { ReferralStatus } from '@/types/referral';

const statusConfig: Record<
  ReferralStatus,
  { label: string; className: string }
> = {
  SIGNED_UP: { label: 'Signed up', className: 'p-signed' },
  CHANNEL_CONNECTED: { label: 'Connected', className: 'p-pending' },
  QUALIFIED: { label: 'Qualifying', className: 'p-qual' },
  ACTIVE: { label: 'Reward unlocked', className: 'p-active' },
  COMPLETED: { label: 'Paid out', className: 'p-completed' },
  EXPIRED: { label: 'Expired', className: 'p-expired' },
};

export const ReferralStatusBadge = ({ status }: { status: ReferralStatus }) => {
  const config = statusConfig[status];

  return (
    <span className={`status-pill ${config.className}`}>{config.label}</span>
  );
};
